import { render } from "./CotizacionComponent.vue?vue&type=template&id=3ea52fa3"
import script from "./CotizacionComponent.vue?vue&type=script&lang=js"
export * from "./CotizacionComponent.vue?vue&type=script&lang=js"

import "./CotizacionComponent.vue?vue&type=style&index=0&id=3ea52fa3&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__